import { environment } from 'environments/environment';
export class Credentials {
  sid = environment.SERVICE_ID;
  constructor(public username: String, public password: String) {}
}
